import DevicesPopup from './DevicesPopup';

export default DevicesPopup;
